import { tokens } from 'src/design-system';
import { commonStyles, buttonStyle, commonStyleSheet } from "src/Library/CommonStyles";

export const uploadSIModalStyles = (theme) => ({
  modal: {
    width: '100% !important',
    top: 0,
    '& .ant-modal-body': {
      padding: 0,
    },
    '& .ant-modal-footer': {
      position: 'sticky',
      bottom: 0,
      backgroundColor: tokens.colors.bgWhite,
      width: '100%',
      paddingRight: '7%',
    },
  },
  processSteps: {
    backgroundColor: '#FCFCFC',
    padding: '22px 22px',
    '& .ant-steps-item-finish .ant-steps-item-icon': {
      backgroundColor: '#44D13D',
      color: tokens.colors.bgWhite,
      borderColor: tokens.colors.bgWhite,
      '& .ant-steps-icon': {
        color: tokens.colors.bgWhite,
      },
    },
    '& .ant-steps-item-title': {
      fontSize: tokens.fontSize.body,
      fontWeight: tokens.fontWeight.semibold,
    },
  },
  partiesInvolvedRow: {
    marginBottom: tokens.spacing.ms,
  },
  addMore: {
    cursor: 'pointer',
    color: tokens.colors.primary,
  },
  selectField: {
    width: '100%',
    '& .ant-select-selection__placeholder, .ant-select-search__field__placeholder': {
      fontSize: tokens.fontSize.small,
    },
    '& .ant-select-selection-selected-value': {
      fontSize: tokens.fontSize.small,
    },
  },
  parentDiv: {
    padding: `0 ${tokens.spacing.lg}px 30px ${tokens.spacing.lg}px`,
  },
  contentHeading: {
    fontSize: tokens.fontSize.h3,
    color: '#424242',
    fontWeight: 'bold',
  },
  boxIcon: {
    width: '20%',
    fontSize: tokens.fontSize.h3,
    color: tokens.colors.textSecondary,
    textAlign: 'left',
  },
  contentLabel: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
  },
  inputField: {
    width: '100%',
    fontSize: `${tokens.fontSize.small}px !important`,
  },
  contentDiv: {
    padding: '36px 0',
    borderBottom: '1px solid rgba(0,0,0,0.15)',
  },
  label: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    marginTop: '9px',
    color: '#303030',
    paddingRight: `${tokens.spacing.sm}px`,
  },
  dryPort: {
    backgroundColor: '#DBECFB',
    color: '#1C4B78',
    fontSize: tokens.fontSize.caption,
    border: '1px solid #1C4B78',
    borderRadius: tokens.radius.sm,
    padding: '0px 3px',
    verticalAlign: 'top',
    float: 'right',
  },
  justifySpaceBetween: {
    ...commonStyles(theme).justifySpaceBetween,
    alignItems: 'center',
  },
  saveDraftButton: {
    fontSize: tokens.fontSize.small,
    borderColor: '#999999',
    height: 28,
    marginRight: tokens.spacing.sm,
  },
  submitButton: {
    marginRight: tokens.spacing.md,
    height: 28,
    borderRadius: tokens.radius.md,
    fontSize: tokens.fontSize.small,
    backgroundColor: `${tokens.colors.primaryDark} !important`,
    border: `1px solid ${tokens.colors.primaryDark}`,
  },
  cargoTypePatch: {
    background: tokens.colors.bgWhite,
    height: 62,
    alignItems: 'center',
    padding: tokens.spacing.lg,
    display: 'flex',
    marginTop: tokens.spacing.xs,
  },
  flexRow: {
    ...commonStyles(theme).flexRow,
  },
  textAreaField: {
    width: '100%',
    fontSize: `${tokens.fontSize.small}px !important`,
  },
  inputNumberField: {
    width: '100%',
    fontSize: `${tokens.fontSize.small}px !important`,
  },
  flexColumn: {
    ...commonStyles(theme).flexColumn,
  },
  textAreaLabel: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    color: '#303030',
    paddingRight: `${tokens.spacing.sm}px`,
  },
  containerDiv: {
    margin: `0 ${tokens.spacing.md}px 0 48px`,
    borderBottom: '1px solid rgba(0,0,0,0.15)',
    padding: `36px 0 ${tokens.spacing.lg}px 0`,
  },
  addContainerButton: {
    ...buttonStyle('#FFFFFF', tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
    borderRadius: tokens.radius.sm,
    fontSize: tokens.fontSize.small,
    padding: '0 15px',
  },
  singleCargo: {
    borderLeft: '1px solid #D9D9D9',
    paddingLeft: '30px',
  },
  totalContainerCargo: {
    width: '100%',
    backgroundColor: '#fff',
    padding: `${tokens.spacing.ms}px ${tokens.spacing.lg}px`,
    color: '#424242',
    marginTop: tokens.spacing.lg,
  },
  paymentDetails: {
    marginBottom: tokens.spacing.sm,
  },
  datePicker: {
    width: '100%',
    '& .ant-calendar-picker-input.ant-input': {
      fontSize: `${tokens.fontSize.small}px !important`,
    },
  },
  successButton: {
    ...buttonStyle('#FFFFFF', tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
    padding: '0 20px',
  },
  successModal: {
    '& .ant-modal-header': {
      padding: 0,
      borderBottom: 'rgba(0,0,0,0.09)',
    },
    '& .ant-modal-body': {
      padding: 0,
    },
  },
  successModalBody : {
    '& .ant-modal-body': {
      padding: tokens.spacing.md,
    },
  },
  successHeader: {
    backgroundColor: '#F9F9F9',
    color: '#424242',
    fontSize: tokens.fontSize.body,
    padding: `${tokens.spacing.lg}px ${tokens.spacing.md}px`,
  },
  suggestedActionsDiv: {
    ...commonStyles(theme).flexRowDiv,
    marginTop: tokens.spacing.ms,
  },
  suggestedActions: {
    border: '1px solid #D9D9D9',
    borderRadius: tokens.radius.md,
    padding: '6px',
    color: '#262626',
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.small,
    cursor: 'pointer',
  },
  newRequestButton: {
    ...buttonStyle('#FFFFFF', tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
    borderRadius: tokens.radius.sm,
    padding: '0 11px',
  },
  collapse: {
    backgroundColor: tokens.colors.bgWhite,
    border: '1px solid #D9D9D9',
    borderRadius: tokens.radius.md,
    '& .ant-collapse-item:first-child': {
      fontWeight: tokens.fontWeight.semibold,
      fontSize: tokens.fontSize.h3,
      color: '#262626',
    },
    '& .ant-collapse-content > .ant-collapse-content-box': {
      padding: 0,
    },
  },
  collapseContent: {
    padding: `${tokens.spacing.ms}px 27px`,
    borderBottom: '1px solid #D9D9D9',
    cursor: 'pointer',
    backgroundColor: '#FCFCFC',
  },
  createAddressStyle: {
    color: tokens.colors.primary,
    margin: '15px',
    cursor: 'pointer',
  },
  clearButton: {
    ...buttonStyle('#F5222D', '#FFFFFF', '1px solid #F5222D'),
    padding: '0 25px',
    borderRadius: tokens.radius.sm,
    fontSize: tokens.fontSize.h3,
  },
  addAddressButton: {
    ...buttonStyle('#FFFFFF', tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
    padding: '0 25px',
    borderRadius: tokens.radius.sm,
    fontSize: tokens.fontSize.h3,
  },
  suffixIcon: {
    '&:hover': {
      '& .ant-select-arrow': {
        right: '30px !important',
      }
    },
  },
  documentLabel: {
    fontWeight: tokens.fontWeight.semibold,
    color: '#303030',
    paddingRight: `${tokens.spacing.sm}px`,
  },
  documentSubHeading: {
    color: tokens.colors.textSecondary,
    fontSize: tokens.fontSize.small,
  },
  documentHeading: {
    fontWeight: tokens.fontWeight.semibold,
    padding: '0 0 8px 4px',
    borderBottom: '1px solid #D9D9D9',
    marginBottom: tokens.spacing.lg,
    color: '#424242',
  },
  oneCargoLabel: {
    color: '#25BA2B',
    fontStyle: 'italic',
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.small,
  },
  dot: {
    height: '12px',
    width: '12px',
    borderRadius: '20px',
    display: 'inline-block',
  },
  additionalDetailsCargo: {
    fontWeight: 'bold',
    margin: '14px 0',
    color: tokens.colors.textSecondary,
  },
  flexRowDiv: {
    ...commonStyles(theme).flexRowDiv,
  },
  header: {
    ...commonStyleSheet.flexRow,
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.h1,
    color: '#000000',
    height: 32,
  },
  tab: {
    textAlign: 'center',
    width: '20%',
    color: '#111',
    fontSize: tokens.fontSize.body,
    cursor: 'pointer',
    padding: 14,
  },
  footer: {
    ...commonStyleSheet.footer,
    ...commonStyleSheet.flexRow,
    height: 65,
    justifyContent: 'flex-start',
    paddingRight: '20%',
    fontSize: tokens.fontSize.body,
    backgroundColor: 'white',
    borderTop: `1px solid ${tokens.colors.border}`,
    opacity: 1,
  },
  main: {
    fontFamily: 'Open Sans',
    letterSpacing: 0,
    '& .ant-drawer-header': {
      padding: tokens.spacing.ms,
      position: 'absolute',
      zIndex: 10,
      width: '100%',
    },
    '& .ant-drawer-body': {
      marginTop: 56,
      padding: 0,
      backgroundColor: '#F1EEE7',
    },
    marginBottom: 100,
  },
  box: {
    ...commonStyleSheet.flexRow,
    marginBottom: tokens.spacing.ms,
    padding: 20,
    alignItems: 'normal',
    boxSizing: 'border-box',
    border: '1px solid #F7F7F7',
    borderRadius: tokens.radius.md,
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
    backgroundColor: tokens.colors.bgWhite,
  },
  pageSelector: {
    ...commonStyleSheet.flexRow,
    boxSizing: 'border-box',
    border: '1px solid #FAF6EF',
    borderRadius: tokens.radius.md,
    backgroundColor: '#FCFAF4',
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
    height: 80,
  },
  tabSelector: {
    padding: 20,
    ...commonStyleSheet.flexRow,
    alignItems: 'center',
    width: '30%',
    cursor: 'pointer',
  },
  filledCircle: {
    height: 20,
    width: 20,
    borderRadius: 10,
    border: '2px solid #FFF',
  },
  tabIcon: {
    height: tokens.spacing.lg,
    width: tokens.spacing.lg,
    borderRadius: 12,
  },
  tabName: {
    marginLeft: tokens.spacing.sm,
    color: tokens.colors.text,
    fontSize: tokens.fontSize.body,
  },
  tabDescription: {
    fontSize: tokens.fontSize.caption,
    marginLeft: tokens.spacing.sm,
  },
  greenCheck: {
    color: '#27B479',
    fontSize: tokens.spacing.lg,
  },
});
